export default function ModalShell({ children, onClose }) {
  return (
    <div className="modal-wrapper">
      <div className="modal-shell">
        {children}
        {onClose && 
          <button onClick={onClose} style={{ marginTop: "1rem" }}>
            Close
          </button>
        }
      </div>
    </div>
  );
}
